module.exports = __webpack_public_path__ + "img/img3.78f6bd81.svg";